import AWS from "aws-sdk";

import AWSConfig from "./aws-export";

import notify from 'utils/modern_notify';

AWS.config.update({
    ...AWSConfig,
});

const s3 = new AWS.S3();

export const buscarImagens = ({ bucket, key }) => {
    const params = {
        Bucket: bucket ? bucket : "imagensazapfy",
        Key: key ? key : "",
    };

    return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
            if (err) {
                resolve(undefined);
            } else {
                const url = transformUint8ArrayToUrl({ data });
                resolve(url);
            }
        });
    });
};

export const buscarAllImagens = ({ bucket, keys }) => {
    return Promise.all(
        keys.map(key => buscarImagem({ bucket, key }))
    ).then(results => results.filter(url => url !== undefined)); // Filtra URLs válidos
};

export const buscarImagemS3InBase64 = ({ bucket, key }) => {
    const params = {
        Bucket: bucket ? bucket : "imagensazapfy",
        Key: key ? key : "",
    };

    return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
            if (err) {
                reject(err);
            } else {
                const blob = new Blob([data.Body], { type: data.ContentType });
                var render = new FileReader()
                render.readAsDataURL(blob)
                render.onload = () => {
                    var base64 = render.result;

                    resolve(base64);
                }
            }
        });
    });
};

export const buscarImagem = ({ bucket, key }) => {
    const params = {
        Bucket: bucket ? bucket : "imagensazapfy",
        Key: key ? key : "",
    };

    return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
            if (err) {
                reject(err);
            } else {
                const url = transformUint8ArrayToUrl({ data });
                resolve(url);
            }
        });
    });
};

export const deletarImagem = ({ bucket, key }) => {
    const params = {
        Bucket: bucket ? bucket : "imagensazapfy",
        Key: key ? key : "",
    };

    return new Promise((resolve, reject) => {
        s3.deleteObject(params, (err, data) => {
            if (err) {
                reject(err);
            } else {
                resolve(data);
            }
        });
    });
};

export const criarImagem = async ({ files }) => {
    const array = [];

    const promises = files.map(async (el) => {
        var upload = new AWS.S3.ManagedUpload({
            params: {
                Bucket: "imagensazapfy",
                Body: el.file,
                Key: el.key ? el.key : "",
                ...(el.file?.type) && {
                    ContentType: el.file.type
                }
            },
        });

        var promise = upload.promise();

        return promise.then(
            function (data) {
                array.push(data.key);
                return data.key;
            },
            function (err) {
                return notify("Erro no upload da imagem");
            }
        );
    });

    await Promise.all(promises);

    return array;
};

const transformUint8ArrayToUrl = ({ data }) => {
    const blob = new Blob([data.Body], { type: data.ContentType });
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(blob);
    return imageUrl;
};
